<template>
  <b-form method="POST" @submit.prevent="submitInput">
    <!-- <b-row v-if="!$root.isAppReviewer">
      <b-col v-bind="cols">
        <asset-block :field="{ label: $t('users.labels.updateProfilePicture'), type: 'IMAGE' }" v-model="form.profileImage"/>
      </b-col>
    </b-row>
    <hr/> -->
    <b-row>
      <b-col v-bind="cols">
        <b-form-group :label="$t('users.labels.firstName')" label-for="firstName">
          <b-form-input id="firstName" type="text" :placeholder="$t('users.ctas.enterFirstName')" required v-model="form.firstName"
            :class="{ 'is-invalid': typeof formValid.firstName === 'string' }"/>
          <div v-if="typeof formValid.firstName === 'string'" class="invalid-feedback">
            <template v-if="formValid.firstName === 'EMPTY'">{{ $t('users.errors.missingFirstName') }}</template>
            <template v-else-if="formValid.firstName === 'TOO_SHORT'">{{ $t('users.errors.tooShortFirstName') }}</template>
            <template v-else>{{ formValid.firstName }}</template>
          </div>
        </b-form-group>
      </b-col>
      <b-col v-bind="cols">
        <b-form-group :label="$t('users.labels.lastName')" label-for="lastName">
          <b-form-input id="lastName" type="text" :placeholder="$t('users.ctas.enterLastName')" required v-model="form.lastName"
            :class="{ 'is-invalid': typeof formValid.lastName === 'string' }"/>
          <div v-if="typeof formValid.lastName === 'string'" class="invalid-feedback">
            <template v-if="formValid.lastName === 'EMPTY'">{{ $t('users.errors.missingLastName') }}</template>
            <template v-else-if="formValid.lastName === 'TOO_SHORT'">{{ $t('users.errors.tooShortLastName') }}</template>
            <template v-else>{{ formValid.lastName }}</template>
          </div>
        </b-form-group>
      </b-col>
      <b-col v-bind="cols">
        <b-form-group :label="$t('users.labels.emailAddress')" label-for="emailAddress">
          <b-form-input id="emailAddress" disabled type="email" :value="value.emailAddress"/>
          <!-- <b-form-text><a href="#" @click.prevent="() => false">Change email</a> - <a href="#" @click.prevent="() => false">Reset password</a></b-form-text> -->
        </b-form-group>
      </b-col>
      <b-col v-bind="cols" v-if="asAdmin">
        <b-form-group :label="$t('users.labels.role')" label-for="role">
          <b-form-select id="role" :options="userRoleEnums" v-model="form.role"/>
        </b-form-group>
      </b-col>
      <b-col v-bind="cols" v-if="Object.keys(userLocaleEnums || {}).length">
        <b-form-group :label="$t('users.labels.locale')" label-for="locale">
          <b-form-select id="locale" :options="userLocaleEnums" @input="value => form.locale = value" :value="form.locale || null">
            <template v-slot:first><option :value="null">{{ $t('ctas.use-default') }}</option></template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <!-- <b-col v-bind="cols">
        <b-form-group :label="$t('users.labels.companyName')" label-for="company">
          <b-form-input id="company" type="text" :placeholder="$t('users.placeholders.companyName')" v-model="form.company"/>
        </b-form-group>
      </b-col>
      <b-col v-bind="cols">
        <b-form-group :label="$t('users.labels.jobTitle')" label-for="title">
          <b-form-input id="title" type="text" :placeholder="$t('users.placeholders.jobTitle')" v-model="form.title"/>
        </b-form-group>
      </b-col> -->
    </b-row>
    <b-row v-if="isGROWMARK">
      <b-col>
          <label class="d-block">Your Location</label>
          <p>{{ location }} <a href="/register/questions">(change)</a></p>
      </b-col>
    </b-row>
    <hr/>
    <template v-if="canSelectDepartment || canSelectLocation">
      <b-row>
        <b-col v-bind="cols" v-if="canSelectDepartment">
          <b-form-group :label="$root.departmentLabel" label-for="departmentSelector">
            <b-form-select id="departmentSelector" :options="departmentOptions" v-model="selectedDepartmentID"
              :required="value.role === 'EMPLOYEE' && !asAdmin">
                <template v-slot:first><option :value="null">{{ $t('ctas.select-option') }}</option></template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-bind="cols" v-if="canSelectLocation">
          <b-form-group :label="$t('users.labels.location')" label-for="locationSelector">
            <location-search id="locationSelector" v-model="selectedLocation" :required="value.role === 'EMPLOYEE' && !asAdmin"/>
          </b-form-group>
        </b-col>
      </b-row>
      <hr/>
    </template>
    <!-- <b-row>
      <b-col v-bind="cols">
        <b-form-group label="Preferences">
          <b-form-checkbox v-model="form.preferences.receiveWeeklyEmails">{{ $t('users.labels.preferences.receiveWeeklyEmails') }}</b-form-checkbox>
          <b-form-checkbox v-model="form.preferences.receiveReengagementEmails">{{ $t('users.labels.preferences.receiveReengagementEmails') }}</b-form-checkbox>
          <b-form-checkbox v-model="form.preferences.visibleInLeaderboards">{{ $t('users.labels.preferences.visibleInLeaderboards') }}</b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row> -->
    <hr/>
    <template v-if="!asAdmin">
      <p><strong>{{ $t('users.delete-account.title') }}</strong></p>
      <p>{{ $t('users.delete-account.description') }}</p>
      <hr/>
    </template>
    <b-row>
      <b-col cols="12" class="text-right">
        <slot name="buttonActions" v-bind:changed="changed">
          <b-form-group>
            <b-button size="md" type="submit" :disabled="!changed" variant="primary">{{ $t('content-fetch.buttons.save') }}</b-button>
          </b-form-group>
        </slot>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import enumsMixin from '@/mixins/enums';
import formValidationMixin from '@src/mixins/formValidation';
import AssetBlock from '@/components/settings/AssetBlock';
import LocationSearch from '@src/components/misc/LocationSearch';
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    company: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    asAdmin: {
      type: Boolean,
      default: false,
    },
    inModal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AssetBlock,
    LocationSearch,
  },
  mixins: [
    enumsMixin,
    formValidationMixin,
  ],
  data: () => ({
    form: {},
    selectedDepartmentID: null,
    selectedLocation: null,
    updateCustomFields: {},
  }),
  created() {
    this.onResetForm();
  },
  formValidation: {
    firstName(value) {
      if (value && value.length <= 2) {
        return 'TOO_SHORT';
      } else if (!value) {
        return 'EMPTY';
      } else {
        return true;
      }
    },
    lastName(value) {
      if (value && value.length <= 2) {
        return 'TOO_SHORT';
      } else if (!value) {
        return 'EMPTY';
      } else {
        return true;
      }
    },
    company(value) {
      if (value && value.length <= 2) {
        return 'TOO_SHORT';
      } else {
        return true;
      }
    },
    title(value) {
      if (value && value.length <= 2) {
        return 'TOO_SHORT';
      } else {
        return true;
      }
    },
  },
  computed: {
    ...mapRoot([ 'user', 'isGROWMARK' ]),
    changed() {
      return JSON.stringify(this.value) !== JSON.stringify(this.form);
    },
    cols() {
      if (this.inModal) {
        return {
          cols: 12,
          sm: 12,
          md: 6,
        };
      } else {
        return {
          cols: 12,
          sm: 6,
          md: 4,
        };
      }
    },
    canSelectDepartment() {
      const { asAdmin, company: { departments, preferences: { askUserForDepartment } } } = this;
      return Array.isArray(departments) && departments.length && (asAdmin || askUserForDepartment);
    },
    // canSelectLanguage() {
    //   const { asAdmin, company: { preferences: { askUserForLanguage, supportedLanguages } } } = this;
    //   return Array.isArray(supportedLanguages) && supportedLanguages.length && (asAdmin || askUserForLanguage);
    // },
    canSelectLocation() {
      const { asAdmin, company: { preferences: { askUserForLocation } } } = this;
      return asAdmin || askUserForLocation;
    },
    customFields() {
      if (this.company && Array.isArray(this.company.customFields) && this.company.customFields.length) {
        return this.company.customFields.map(({ options, departments, ...field }) => ({
          ...field,
          options: options ? JSON.parse(options) : null,
          departments: departments ? departments.map(({ id }) => id) : null,
        }));
      } else {
        return [];
      }
    },
    departmentOptions() {
      if (this.company && Array.isArray(this.company.departments) && this.company.departments.length) {
        return this.company.departments.map(({ id, name }) => ({ text: name, value: id }));
      } else {
        return {};
      }
    },
    location() {
      if (this.user && this.user.customFields && Array.isArray(this.user.customFields)) {
        const locationField = this.user.customFields.find((field) => field.key === 'CUSTOM-LOCATION');
        const locationValue = locationField.value;
        return locationValue;
      } else {
        return 'Not set';
      }
    }
  },
  methods: {
    onResetForm() {
      const {
        firstName, lastName, locale, title, profileImage,
        departments, location, customFields, preferences,
      } = this.value;

      this.form = {
        firstName: firstName || null,
        lastName: lastName || null,
        locale: locale || null,
        title: title || null,
        profileImage: profileImage ? JSON.parse(JSON.stringify(profileImage)) : null,
        preferences: preferences || {},
      };

      if (Array.isArray(departments) && departments.length) {
        const [ { id: departmentID } ] = departments;
        this.selectedDepartmentID = departmentID;
      } else {
        this.selectedDepartmentID = null;
      }

      if (location && location.id) {
        this.selectedLocation = location;
      } else {
        this.selectedLocation = null;
      }

      if (this.asAdmin) {
        const { company, role, status } = this.value;
        this.form = {
          ...this.form,
          company: company || null,
          role: role || null,
          status: status || null,
        };
      }

      if (Array.isArray(customFields) && customFields.length) {
        this.updateCustomFields = customFields.reduce((values, { key, value }) => ({ ...values, [key]: value }), {});
      } else {
        this.updateCustomFields = {};
      }
    },
    submitInput() {
      const input = JSON.parse(JSON.stringify(this.form));

      if (input.profileImage && input.profileImage.id) {
        input.profileImage = { id: input.profileImage.id };
      } else {
        input.profileImage = null;
      }

      if (this.selectedDepartmentID) {
        input.departments = { id: this.selectedDepartmentID };
      } else {
        input.departments = null;
      }

      if (this.selectedLocation && this.selectedLocation.id) {
        const { id: locationID } = this.selectedLocation;
        input.location = { id: locationID };
      } else {
        input.location = null;
      }

      if (Object.keys(this.updateCustomFields)) {
        input.customFields = Object.keys(this.updateCustomFields).map(key => ({
          key,
          value: this.updateCustomFields[key],
        }));
      }

      if (input.preferences) {
        delete input.preferences.__typename;
      }

      this.$emit('input', input);
    },
  },
  watch: {
    value() {
      this.onResetForm();
    },
    selectedDepartmentID(departmentID) {
      this.customFields.forEach(({ key, departments }) => {
        if (Array.isArray(departments) && !departments.includes(departmentID)) {
          this.updateCustomFields[key] = null;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/users/EditProfileForm.vue